export enum AllocationsGainLossEnum {
    Gain = 'gain',
    Loss = 'loss',
}
